<template>
  <div class="contract-detail-page">

    <!-- 顶部合同基本信息 -->
    <div class="contract-header">
      <div class="contract-header-top">
        <div class="contract-title">
          <span class="serial">{{ detail.serial_number || detail.sn }}</span>
          <span class="name">{{ detail.name || '-' }}</span>
          <el-tag v-if="stageText" type="success" size="small">{{ stageText }}</el-tag>
        </div>
        <div class="contract-meta">
          <span>客户：{{ detail.customer_name || detail.customer_text || '-' }}</span>
          <span>商机：{{ detail.opportunitie_text || detail.opportunitie_name || '-' }}</span>
        </div>
      </div>

      <el-descriptions :column="4" border size="small" class="contract-info">
        <el-descriptions-item label="销售金额">¥{{ detail.sales_amount || '0.00' }}</el-descriptions-item>
        <el-descriptions-item label="租赁金额">¥{{ detail.room_amount || '0.00' }}</el-descriptions-item>
        <el-descriptions-item label="合同编号">{{ detail.serial_number || '-' }}</el-descriptions-item>
        <el-descriptions-item label="签订日期">{{ detail.signing_date || '-' }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ detail.start_date || '-' }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ detail.end_date || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ detail.contacts || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ detail.phone || '-' }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <!-- 合同阶段时间线 -->
    <div class="contract-stage">
      <el-steps :active="stageActive" finish-status="success" align-center>
        <el-step title="待执行"></el-step>
        <el-step title="已预定"></el-step>
        <el-step title="已支付"></el-step>
        <el-step title="已全款"></el-step>
      </el-steps>
    </div>

    <!-- Tab 切换 + 各 tab 列表 -->
    <div class="contract-body">
      <el-tabs v-model="activeTab" type="border-card" @tab-click="onTabClick">

        <!-- 资料：合同财务汇总 + 基础信息 -->
        <el-tab-pane label="资料" name="info">
          <div class="info-summary">
            <div class="section-title">会议信息</div>
            <el-descriptions :column="3" border size="small">
              <el-descriptions-item label="订单总金额">¥{{ detail.total_amount || detail.sales_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="订单支付金额">¥{{ detail.total_payment_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="订单退款金额">¥{{ detail.financial_refun_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="订单实际支付金额">¥{{ detail.payment_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="订单待支付金额">¥{{ detail.pending_payment_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="充值金额">¥{{ detail.recharge_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="抵扣金额">¥{{ detail.deduction_amount || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="非余额支付">¥{{ detail.non_balance_payment || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="余额支付">¥{{ detail.balance_payment || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="退款现金给客户">¥{{ detail.refund_cash || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="退款到订单的余额">¥{{ detail.refund_to_balance || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="转移来的余额">¥{{ detail.transfer_in_balance || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="转移出的余额">¥{{ detail.transfer_out_balance || '0.00' }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </el-tab-pane>

        <!-- 会议室预订单 -->
        <el-tab-pane label="会议室预订单" name="roomOrder">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadRoomOrderList">刷新</el-button>
          </div>
          <el-table :data="roomOrderList" v-loading="loading.roomOrder" stripe border size="small">
            <el-table-column prop="serial_number" label="预定编号" min-width="140"></el-table-column>
            <el-table-column prop="room_name" label="会议室" min-width="120"></el-table-column>
            <el-table-column prop="store_name" label="门店" min-width="120"></el-table-column>
            <el-table-column prop="on_site_time" label="到场日期" min-width="110"></el-table-column>
            <el-table-column prop="start_time" label="时段" min-width="120"></el-table-column>
            <el-table-column prop="number_people" label="人数" width="80"></el-table-column>
            <el-table-column prop="amount" label="金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.roomOrder.total>0" layout="total, prev, pager, next" :total="pager.roomOrder.total" :page-size="pager.roomOrder.pageSize" :current-page.sync="pager.roomOrder.page" @current-change="loadRoomOrderList"></el-pagination>
        </el-tab-pane>

        <!-- 增值服务订单 -->
        <el-tab-pane label="增值服务订单" name="addedService">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadAddedServiceList">刷新</el-button>
          </div>
          <el-table :data="addedServiceList" v-loading="loading.addedService" stripe border size="small">
            <el-table-column prop="serial_number" label="订单编号" min-width="140"></el-table-column>
            <el-table-column prop="on_date" label="服务日期" min-width="110"></el-table-column>
            <el-table-column prop="value_added_services_name" label="服务类型" min-width="120"></el-table-column>
            <el-table-column prop="value_added_services_goods_name" label="服务项" min-width="150"></el-table-column>
            <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
            <el-table-column prop="unit_price" label="单价" width="100">
              <template slot-scope="scope">¥{{ scope.row.unit_price || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="amount" label="金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.addedService.total>0" layout="total, prev, pager, next" :total="pager.addedService.total" :page-size="pager.addedService.pageSize" :current-page.sync="pager.addedService.page" @current-change="loadAddedServiceList"></el-pagination>
        </el-tab-pane>

        <!-- 支付单 -->
        <el-tab-pane label="支付单" name="payment">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadPaymentList">刷新</el-button>
          </div>
          <el-table :data="paymentList" v-loading="loading.payment" stripe border size="small">
            <el-table-column prop="serial_number" label="支付单号" min-width="140"></el-table-column>
            <el-table-column prop="payment_date" label="支付日期" min-width="110"></el-table-column>
            <el-table-column prop="payment_type_name" label="支付类型" min-width="120"></el-table-column>
            <el-table-column prop="payment_method" label="支付方式" min-width="120"></el-table-column>
            <el-table-column prop="amount" label="金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="number" label="流水号" min-width="160"></el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.payment.total>0" layout="total, prev, pager, next" :total="pager.payment.total" :page-size="pager.payment.pageSize" :current-page.sync="pager.payment.page" @current-change="loadPaymentList"></el-pagination>
        </el-tab-pane>

        <!-- 回款计划 -->
        <el-tab-pane label="回款计划" name="collection">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadCollectionList">刷新</el-button>
          </div>
          <el-table :data="collectionList" v-loading="loading.collection" stripe border size="small">
            <el-table-column prop="serial_number" label="回款编号" min-width="140"></el-table-column>
            <el-table-column prop="payment_date" label="计划回款日期" min-width="120"></el-table-column>
            <el-table-column prop="amount" label="回款金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="actual_amount" label="实收金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.actual_amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="payment_method" label="回款方式" min-width="120"></el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.collection.total>0" layout="total, prev, pager, next" :total="pager.collection.total" :page-size="pager.collection.pageSize" :current-page.sync="pager.collection.page" @current-change="loadCollectionList"></el-pagination>
        </el-tab-pane>

        <!-- 余额明细 -->
        <el-tab-pane label="余额明细" name="balance">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadBalanceList">刷新</el-button>
          </div>
          <el-table :data="balanceList" v-loading="loading.balance" stripe border size="small">
            <el-table-column prop="serial_number" label="流水号" min-width="160"></el-table-column>
            <el-table-column prop="change_time" label="变动时间" min-width="150"></el-table-column>
            <el-table-column prop="change_type_name" label="变动类型" min-width="120"></el-table-column>
            <el-table-column prop="amount" label="变动金额" width="120">
              <template slot-scope="scope">
                <span :class="scope.row.amount>=0?'amount-plus':'amount-minus'">{{ scope.row.amount>=0?'+':'-' }}¥{{ Math.abs(scope.row.amount || 0).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="balance" label="余额" width="120">
              <template slot-scope="scope">¥{{ scope.row.balance || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.balance.total>0" layout="total, prev, pager, next" :total="pager.balance.total" :page-size="pager.balance.pageSize" :current-page.sync="pager.balance.page" @current-change="loadBalanceList"></el-pagination>
        </el-tab-pane>

        <!-- 财务合同 -->
        <el-tab-pane label="财务合同" name="financeContract">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadFinanceContractList">刷新</el-button>
          </div>
          <el-table :data="financeContractList" v-loading="loading.financeContract" stripe border size="small">
            <el-table-column prop="serial_number" label="财务合同编号" min-width="160"></el-table-column>
            <el-table-column prop="company_name" label="签约主体" min-width="200"></el-table-column>
            <el-table-column prop="signing_date" label="签约日期" min-width="110"></el-table-column>
            <el-table-column prop="total_amount" label="合同金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.total_amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.financeContract.total>0" layout="total, prev, pager, next" :total="pager.financeContract.total" :page-size="pager.financeContract.pageSize" :current-page.sync="pager.financeContract.page" @current-change="loadFinanceContractList"></el-pagination>
        </el-tab-pane>

        <!-- 财务发票 -->
        <el-tab-pane label="财务发票" name="financeInvoice">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadFinanceInvoiceList">刷新</el-button>
          </div>
          <el-table :data="financeInvoiceList" v-loading="loading.financeInvoice" stripe border size="small">
            <el-table-column prop="serial_number" label="发票编号" min-width="140"></el-table-column>
            <el-table-column prop="type_name" label="发票类型" min-width="120"></el-table-column>
            <el-table-column prop="buyer_name" label="购买方" min-width="180"></el-table-column>
            <el-table-column prop="buyer_tax_no" label="税号" min-width="160"></el-table-column>
            <el-table-column prop="amount" label="金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="signing_date" label="开票日期" min-width="110"></el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.financeInvoice.total>0" layout="total, prev, pager, next" :total="pager.financeInvoice.total" :page-size="pager.financeInvoice.pageSize" :current-page.sync="pager.financeInvoice.page" @current-change="loadFinanceInvoiceList"></el-pagination>
        </el-tab-pane>

        <!-- 退款单 -->
        <el-tab-pane label="退款单" name="refund">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadRefundList">刷新</el-button>
          </div>
          <el-table :data="refundList" v-loading="loading.refund" stripe border size="small">
            <el-table-column prop="serial_number" label="退款编号" min-width="140"></el-table-column>
            <el-table-column prop="refund_date" label="退款日期" min-width="110"></el-table-column>
            <el-table-column prop="refund_type_name" label="退款类型" min-width="120"></el-table-column>
            <el-table-column prop="amount" label="退款金额" width="120">
              <template slot-scope="scope">¥{{ scope.row.amount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="refund_method" label="退款方式" min-width="120"></el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.refund.total>0" layout="total, prev, pager, next" :total="pager.refund.total" :page-size="pager.refund.pageSize" :current-page.sync="pager.refund.page" @current-change="loadRefundList"></el-pagination>
        </el-tab-pane>

        <!-- 审批 -->
        <el-tab-pane label="审批" name="approval">
          <div class="tab-toolbar">
            <el-button type="primary" size="small" @click="loadApprovalList">刷新</el-button>
          </div>
          <el-table :data="approvalList" v-loading="loading.approval" stripe border size="small">
            <el-table-column prop="serial_number" label="审批编号" min-width="140"></el-table-column>
            <el-table-column prop="approval_type_name" label="审批类型" min-width="120"></el-table-column>
            <el-table-column prop="apply_user_name" label="申请人" min-width="120"></el-table-column>
            <el-table-column prop="apply_time" label="申请时间" min-width="150"></el-table-column>
            <el-table-column prop="current_node_name" label="当前节点" min-width="120"></el-table-column>
            <el-table-column prop="status_name" label="状态" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200"></el-table-column>
          </el-table>
          <el-pagination v-if="pager.approval.total>0" layout="total, prev, pager, next" :total="pager.approval.total" :page-size="pager.approval.pageSize" :current-page.sync="pager.approval.page" @current-change="loadApprovalList"></el-pagination>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getOrdersDetailData,
  getContractRoomOrderListData,
  getContractAddedServiceListData,
  getContractPaymentListData,
  getContractCollectionListData,
  getContractBalanceListData,
  getContractFinanceContractListData,
  getContractInvoiceListData,
  getContractRefundListData,
  getContractApprovalListData
} from "../api/api.js";

export default {
  name: "OrderContractDetail",
  data() {
    return {
      sn: "",
      detail: {},
      activeTab: "info",
      stageMap: { 1: 1, 2: 2, 3: 3, 4: 4 },
      stageNames: { 1: "待执行", 2: "已预定", 3: "已支付", 4: "已全款" },

      loading: {
        detail: false,
        roomOrder: false,
        addedService: false,
        payment: false,
        collection: false,
        balance: false,
        financeContract: false,
        financeInvoice: false,
        refund: false,
        approval: false
      },

      pager: {
        roomOrder: { page: 1, pageSize: 10, total: 0 },
        addedService: { page: 1, pageSize: 10, total: 0 },
        payment: { page: 1, pageSize: 10, total: 0 },
        collection: { page: 1, pageSize: 10, total: 0 },
        balance: { page: 1, pageSize: 10, total: 0 },
        financeContract: { page: 1, pageSize: 10, total: 0 },
        financeInvoice: { page: 1, pageSize: 10, total: 0 },
        refund: { page: 1, pageSize: 10, total: 0 },
        approval: { page: 1, pageSize: 10, total: 0 }
      },

      roomOrderList: [],
      addedServiceList: [],
      paymentList: [],
      collectionList: [],
      balanceList: [],
      financeContractList: [],
      financeInvoiceList: [],
      refundList: [],
      approvalList: []
    };
  },

  computed: {
    stageActive() {
      const s = Number(this.detail.stage || 1);
      return this.stageMap[s] || 1;
    },
    stageText() {
      return this.stageNames[this.detail.stage] || "";
    }
  },

  created() {
    this.sn = this.$route.params.sn || this.$route.query.sn || "";
    if (this.sn) {
      this.loadDetail();
    }
  },

  methods: {
    loadDetail() {
      this.loading.detail = true;
      getOrdersDetailData({ sn: this.sn })
        .then(response => {
          this.loading.detail = false;
          if (response && response.code == 200) {
            this.detail = response.data || {};
          } else {
            this.$message.error(response ? response.msg : "合同详情加载失败");
          }
        })
        .catch(error => {
          this.loading.detail = false;
          console.log(error);
          this.$message.error("合同详情加载异常");
        });
    },

    onTabClick(tab) {
      const name = tab.name;
      if (name === "info") return;
      const methodMap = {
        roomOrder: "loadRoomOrderList",
        addedService: "loadAddedServiceList",
        payment: "loadPaymentList",
        collection: "loadCollectionList",
        balance: "loadBalanceList",
        financeContract: "loadFinanceContractList",
        financeInvoice: "loadFinanceInvoiceList",
        refund: "loadRefundList",
        approval: "loadApprovalList"
      };
      if (methodMap[name]) {
        this[methodMap[name]]();
      }
    },

    handleListResponse(response, listKey, pagerKey) {
      if (response && response.code == 200) {
        const data = response.data || {};
        this[listKey] = data.data || data.list || [];
        this[pagerKey].total = data.total || 0;
      } else {
        this.$message.error(response ? response.msg : "列表加载失败");
      }
    },

    loadRoomOrderList() {
      this.loading.roomOrder = true;
      getContractRoomOrderListData({ sn: this.sn, page: this.pager.roomOrder.page, pageSize: this.pager.roomOrder.pageSize })
        .then(response => { this.loading.roomOrder = false; this.handleListResponse(response, "roomOrderList", "roomOrder"); })
        .catch(error => { this.loading.roomOrder = false; console.log(error); });
    },

    loadAddedServiceList() {
      this.loading.addedService = true;
      getContractAddedServiceListData({ sn: this.sn, page: this.pager.addedService.page, pageSize: this.pager.addedService.pageSize })
        .then(response => { this.loading.addedService = false; this.handleListResponse(response, "addedServiceList", "addedService"); })
        .catch(error => { this.loading.addedService = false; console.log(error); });
    },

    loadPaymentList() {
      this.loading.payment = true;
      getContractPaymentListData({ sn: this.sn, page: this.pager.payment.page, pageSize: this.pager.payment.pageSize })
        .then(response => { this.loading.payment = false; this.handleListResponse(response, "paymentList", "payment"); })
        .catch(error => { this.loading.payment = false; console.log(error); });
    },

    loadCollectionList() {
      this.loading.collection = true;
      getContractCollectionListData({ sn: this.sn, page: this.pager.collection.page, pageSize: this.pager.collection.pageSize })
        .then(response => { this.loading.collection = false; this.handleListResponse(response, "collectionList", "collection"); })
        .catch(error => { this.loading.collection = false; console.log(error); });
    },

    loadBalanceList() {
      this.loading.balance = true;
      getContractBalanceListData({ sn: this.sn, page: this.pager.balance.page, pageSize: this.pager.balance.pageSize })
        .then(response => { this.loading.balance = false; this.handleListResponse(response, "balanceList", "balance"); })
        .catch(error => { this.loading.balance = false; console.log(error); });
    },

    loadFinanceContractList() {
      this.loading.financeContract = true;
      getContractFinanceContractListData({ sn: this.sn, page: this.pager.financeContract.page, pageSize: this.pager.financeContract.pageSize })
        .then(response => { this.loading.financeContract = false; this.handleListResponse(response, "financeContractList", "financeContract"); })
        .catch(error => { this.loading.financeContract = false; console.log(error); });
    },

    loadFinanceInvoiceList() {
      this.loading.financeInvoice = true;
      getContractInvoiceListData({ sn: this.sn, page: this.pager.financeInvoice.page, pageSize: this.pager.financeInvoice.pageSize })
        .then(response => { this.loading.financeInvoice = false; this.handleListResponse(response, "financeInvoiceList", "financeInvoice"); })
        .catch(error => { this.loading.financeInvoice = false; console.log(error); });
    },

    loadRefundList() {
      this.loading.refund = true;
      getContractRefundListData({ sn: this.sn, page: this.pager.refund.page, pageSize: this.pager.refund.pageSize })
        .then(response => { this.loading.refund = false; this.handleListResponse(response, "refundList", "refund"); })
        .catch(error => { this.loading.refund = false; console.log(error); });
    },

    loadApprovalList() {
      this.loading.approval = true;
      getContractApprovalListData({ sn: this.sn, page: this.pager.approval.page, pageSize: this.pager.approval.pageSize })
        .then(response => { this.loading.approval = false; this.handleListResponse(response, "approvalList", "approval"); })
        .catch(error => { this.loading.approval = false; console.log(error); });
    }
  }
};
</script>

<style scoped>
.contract-detail-page {
  padding: 16px;
  background: #f5f6f8;
  min-height: 100vh;
  box-sizing: border-box;
}

/* 头部品牌条 */
.contract-header {
  background: linear-gradient(135deg, #2b5fd9 0%, #4a8af0 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 6px 18px rgba(43, 95, 217, 0.18);
  color: #fff;
}

.contract-header-top {
  margin-bottom: 16px;
}

.contract-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}
.contract-title .serial {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}
.contract-title .name {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
}
.contract-title .el-tag {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.45);
  color: #fff;
}

.contract-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

/* 头部描述列表改为浅底白卡片感 */
.contract-info {
  margin-top: 14px;
}
.contract-info ::v-deep .el-descriptions__label,
.contract-info ::v-deep .el-descriptions__content {
  color: #fff;
}
.contract-info ::v-deep .el-descriptions__body {
  background: transparent;
}
.contract-info ::v-deep .el-descriptions-item__cell {
  border-color: rgba(255, 255, 255, 0.22) !important;
}

.contract-stage {
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 10px rgba(31, 58, 110, 0.06);
}

.contract-body {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(31, 58, 110, 0.06);
  overflow: hidden;
}

.tab-toolbar {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  padding: 14px 16px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
}

.info-summary {
  padding: 8px;
}

.amount-plus { color: #00b42a; font-weight: 600; }
.amount-minus { color: #f53f3f; font-weight: 600; }

.el-pagination {
  padding: 12px 16px;
  text-align: right;
}

/* 品牌色点缀 Element 组件 */
.contract-body ::v-deep .el-tabs__item.is-active {
  color: #2b5fd9;
}
.contract-body ::v-deep .el-tabs__active-bar {
  background-color: #2b5fd9;
}
.contract-body ::v-deep .el-table th {
  background: #f7f8fa;
  color: #1d2129;
}
.contract-body ::v-deep .el-button--primary {
  background: #2b5fd9;
  border-color: #2b5fd9;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderContractDetail.vue